import { ReactNode } from 'react'
import FFLogo from '@forwardflow/assets/ff-onboarding-logo.svg'
import { Stepper } from '../Stepper'
import { SetupRail } from './SetupRail'

/**
 * The two-column setup page. Left: the whole setup at a glance (status of
 * every step). Right: the one step being configured. The header carries
 * the step count and time left; whatever the host page needs on the right
 * (account menu, preview tag) goes in `headerRight`.
 */
export const OnboardingShell = ({
   children,
   headerRight,
   above,
}: {
   children: ReactNode
   headerRight?: ReactNode
   /** Rendered above the columns, full width (banners, dev bar). */
   above?: ReactNode
}) => (
   <div className="relative min-h-screen w-full bg-[#0A0A12] text-white">
      <div
         className="fixed inset-0 opacity-[0.06] pointer-events-none"
         style={{
            background:
               'radial-gradient(60% 50% at 50% 0%, #A684FF 0%, rgba(166, 132, 255, 0) 100%)',
         }}
      />
      <header className="relative z-10 border-b border-white/[0.06]">
         <div className="mx-auto max-w-[1120px] px-4 md:px-6 h-16 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
               <img src={FFLogo} alt="Forward Flow" className="w-9 h-9" />
               <div className="min-w-0">
                  <p className="text-white font-semibold text-sm leading-tight">Set up Forward Flow</p>
                  <Stepper />
               </div>
            </div>
            <div className="flex items-center gap-3 shrink-0">{headerRight}</div>
         </div>
      </header>
      {above}
      <main className="relative z-10 mx-auto max-w-[1120px] px-4 md:px-6 py-5 md:py-7">
         <div className="grid grid-cols-1 lg:grid-cols-[300px_minmax(0,1fr)] gap-5 lg:gap-7 items-start">
            <aside className="lg:sticky lg:top-6 order-2 lg:order-1">
               <SetupRail />
            </aside>
            <section className="order-1 lg:order-2 min-w-0" data-testid="step-panel">
               {children}
            </section>
         </div>
      </main>
   </div>
)
